import React from 'react'; 
import NavBar_v03Responsive from '../../component-library/NavBar_v03a_Responsive_component';

import { IAppConfig } from "../../App_v01_Interfaces";

interface AppConfigProps{
  appConfig: IAppConfig;
}

const PrivacyPolicy_V01A_A2P: React.FC<AppConfigProps> = ({appConfig}) => {
  return (

    <>
    {/* <NavBar_v01 appConfig={appConfig} /> */}
    {/* <NavBar_v03Responsive appConfig={appConfig}></NavBar_v03Responsive> */}


      <div className="container py-5">
        <h1 className="mb-4 text-center">Privacy Policy</h1>
        <p className="text-muted">Effective Date: May 2, 2025</p>

        <section className="mb-4">
          <h4>1. Introduction</h4>
          <p>
            This Privacy Policy explains how we collect, use, and protect your information when you use our website and services. By accessing our site, you agree to the terms outlined in this policy.
          </p>
        </section>

        <section className="mb-4">
          <h4>2. Information We Collect</h4>
          <p>We may collect the following types of information:</p>
          <ul>
            <li>Contact information (e.g., name, email, phone number)</li>
            <li>Business or location information for vending machine placement</li>
            <li>Feedback or inquiries submitted through our contact form</li>
            <li>Usage data (e.g., browser type, time of visit, pages viewed)</li>
          </ul>
        </section>

        <section className="mb-4">
          <h4>3. How We Use Your Information</h4>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Respond to inquiries and service requests</li>
            <li>Evaluate potential vending machine locations</li>
            <li>Improve our website, services, and customer experience</li>
            <li>Send important updates or promotional communications (you can opt out)</li>
          </ul>
        </section>

        {/* A2P / Messaging Compliance (required if you collect/enable SMS) */}
        <section className="mb-4">
          <h4>4. SMS/Text Messaging Privacy &amp; Opt-Out</h4>
          <p>
            If you provide your mobile number and opt in to receive SMS/text messages from us, we will use your phone number to send messages related to our services,
            including (as applicable) appointment confirmations, service updates, support responses, and marketing messages. Message frequency varies. Msg &amp; data rates may apply.
            You can opt out at any time by replying <strong>STOP</strong>; reply <strong>HELP</strong> for help. Consent is not a condition of purchase.
          </p>
          <p>
            We do not sell your phone number. We may share your number with service providers that help us deliver text messages (for example, messaging platforms and carriers),
            and they are required to safeguard your information and use it only to provide services to us.
          </p>
        </section>

        <section className="mb-4">
          <h4>5. Sharing Your Information</h4>
          <p>
            We do not sell your personal information. We may share data with trusted third-party vendors who assist in operating our business, provided they agree to keep it confidential.
          </p>
        </section>

        <section className="mb-4">
          <h4>6. Data Security</h4>
          <p>
            We take reasonable measures to protect your information from unauthorized access, disclosure, or alteration. However, no method of transmission over the internet is 100% secure.
          </p>
        </section>

        <section className="mb-4">
          <h4>7. Cookies & Tracking</h4>
          <p>
            Our website may use cookies to enhance your experience and analyze site traffic. You can adjust your browser settings to disable cookies if you prefer.
          </p>
        </section>

        <section className="mb-4">
          <h4>8. Your Rights</h4>
          <p>
            You have the right to request access to, correction of, or deletion of your personal information. Please contact us at <a href={`mailto:${appConfig.legalEMail}`}>{appConfig.legalEMail}</a> for any privacy-related concerns.
          </p>
        </section>

        <section className="mb-4">
          <h4>9. Changes to This Policy</h4>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
          </p>
        </section>

        <section className="mb-4">
          <h4>10. Contact Us</h4>
          <p>
            If you have any questions or concerns regarding this Privacy Policy, please contact us at <a href={`mailto:${appConfig.legalEMail}`}>{appConfig.legalEMail}</a>.
          </p>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy_V01A_A2P;